
import request from './libs/request'
import sign from './libs/sign'
import base from './libs/base'

const api = {
	//阿里云
	async aliOss(data) {
		return await request.post(`https://rainbowstar.oss-cn-zhangjiakou.aliyuncs.com`, data)
	},
	// config
	async getConfig (params) {
		return request.get(`${ base.BASE_API }/config`, { params: sign.main(params) })
	}
}
export default api


// WEBPACK FOOTER //
// ./src/api/common.js